import { useEffect, useMemo, useState } from 'react';
import { callApi } from 'src/utils/apiCall';
import { mergeCallDetail } from './callLog.normalize';
import { detailUrl } from './callLogQuery';

// Review modal data: on open, GET practices/{p}/calls/{id}/ for the transcript
// and the WhatsApp recordings list. The merged call keeps one identity per
// (row, detail) pair, because the review hooks key their saved state on it.
export default function useCallDetail(practiceId, row) {
  const id = row?.id;
  const [state, setState] = useState({ id: null, detail: null, status: 'idle' });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!practiceId || !id) return undefined;
    const controller = new AbortController();
    setState({ id, detail: null, status: 'loading' });
    callApi(detailUrl(practiceId, id), 'GET', null, false, { signal: controller.signal }).then((response) => {
      if (controller.signal.aborted) return;
      // status 0 is "no answer" (timeout / network), not an empty call: say so.
      if (!response?.ok || !response.data || typeof response.data !== 'object') setState({ id, detail: null, status: 'error' });
      else setState({ id, detail: response.data, status: 'ready' });
    });
    return () => controller.abort();
  }, [practiceId, id, attempt]);
  const current = state.id === id ? state : { detail: null, status: id ? 'loading' : 'idle' };
  const call = useMemo(() => mergeCallDetail(row, current.detail), [row, current.detail]);
  return { call, status: current.status, retry: () => setAttempt((n) => n + 1) };
}
